import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@services/security';

@Injectable()
export class RouteDetectorService {
    constructor(
        private readonly router: Router,
        public authService: AuthService,
    ) {}

    public detectRoute(): void {
        if (this.authService.isAdminMedical) {
            this.router.navigate(['/dashboard/admin']);
            return;
        }

        if (this.authService.isAdminAccounting) {
            this.router.navigate(['/dashboard/accounting']);
            return;
        }

        if (this.authService.isUserMedical) {
            this.router.navigate(['/dashboard/medical']);
            return;
        }

        if (this.authService.isUserManagement) {
            this.router.navigate(['/dashboard/management']);
            return;
        }

        this.router.navigate(['/dashboard/unknown']);
    }
}
